import { Link } from "react-router-dom";
import Slider from "react-slick";

const Ourproducts = () => {
    const slideCateg = {
        infinite: true,
        speed: 500,
        autoplaySpeed: 10000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,        
    };

  return (
    <section className="green-features-area section_padding_100_0 clearfix">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="section-heading text-center mb-0">
                        <h2 className="text-white ">Our Products</h2>
                    </div>
                </div>
            </div>
        </div>

        <div className="workflow-slides-area mt-5 pt-5" id="ourproducts">
            <div className="container">
                <div className="row pt-5">
                    <div className="col-12 pt-4">
                        <div className="mosh-workflow-slides">

                            <Slider {...slideCateg}>
                                <div className="single-workflow-area d-flex px-2">
                                    <h2>1</h2>
                                    <div className="workflow-content ml-15">
                                        <h4><Link to="/products/spillclean-powder">SpillClean&trade; Powder</Link></h4>
                                        <p className="mb-4">Spillage occurs daily around us - at oil 
                                            drilling rigs, petroleum industries. SpillClean quickly 
                                            absorbs and cleans hydrocarbons, oil, fluids, chemicals.</p>

                                        <Link to="/products/spillclean-powder" className="green-links-static">Visit Product Page</Link>
                                    </div>
                                </div>

                                <div className="single-workflow-area d-flex px-2">
                                    <h2>2</h2>
                                    <div className="workflow-content ml-15">
                                        <h4><Link to="/products/fertilizer-and-water-mixing-machine">
                                            Fertilizer and Water Mixing Machine</Link></h4>

                                        <p><i>Brief info about the product</i></p>

                                        <Link to="/products/fertilizer-and-water-mixing-machine" className="green-links-static">Visit Product Page</Link>
                                    </div>
                                </div>

                                <div className="single-workflow-area d-flex px-2">
                                    <h2>3</h2>
                                    <div className="workflow-content ml-15">
                                        <h4><Link to="/products/cocopeat-and-coconut-husk-chips">
                                            Cocopeat and Coconut Husk Chips</Link></h4>

                                        <p><i>Brief info about the product</i></p>

                                        <Link to="/products/cocopeat-and-coconut-husk-chips" className="green-links-static">Visit Product Page</Link>
                                    </div>
                                </div>
                                
                                <div className="single-workflow-area d-flex px-2">
                                    <h2>4</h2>
                                    <div className="workflow-content ml-15">
                                        <h4><Link to="/products/others">Browse other Products by MIPAT</Link></h4>
                                        <p><i>Brief info about other products by MIPAT and their dedicated websites</i></p>

                                        <Link to="/products/others" className="green-links-static">Other Products</Link>
                                    </div>
                                </div>
                            </Slider>

                        </div>
                    </div>
                </div>

                <div className="text-center"><Link to="/products" class="btn mosh-btn mt-5">Browse all products</Link></div>
            </div>
        </div>
    </section>
  )
}
export default Ourproducts;